export const PHARMACY_DATA_UPDATE_STATUS = {
  STARTING: 'STARTING',
  STARTED: 'STARTED',
  STOPPING: 'STOPPING',
  COMPLETED: 'COMPLETED',
} as const

export type PharmacyDataUpdateStatusType =
  (typeof PHARMACY_DATA_UPDATE_STATUS)[keyof typeof PHARMACY_DATA_UPDATE_STATUS]
